/* THIS FILE IS GENERATED. DO NOT EDIT */
// @ts-ignore
            
import * as Types from '@generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganizationsListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrganizationsListQuery = { __typename?: 'Root', organizations: Array<{ __typename?: 'Organization', id?: string | null, name?: string | null, stripeStatus?: Types.StripeStatus | null, stripeAccount?: { __typename?: 'StripeAccount', severity?: Types.StripeAccountSeverity | null } | null, chargeSystems?: Array<{ __typename?: 'ChargeSystem', id: string, name?: string | null }> | null, contactAddress?: { __typename?: 'AddressDetails', country?: string | null } | null } | null> };


export const OrganizationsListDocument = gql`
    query OrganizationsList {
  organizations {
    id
    name
    stripeStatus
    stripeAccount {
      severity
    }
    chargeSystems {
      id
      name
    }
    contactAddress {
      country
    }
  }
}
    `;

/**
 * __useOrganizationsListQuery__
 *
 * To run a query within a React component, call `useOrganizationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationsListQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationsListQuery, OrganizationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationsListQuery, OrganizationsListQueryVariables>(OrganizationsListDocument, options);
      }
export function useOrganizationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationsListQuery, OrganizationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationsListQuery, OrganizationsListQueryVariables>(OrganizationsListDocument, options);
        }
export function useOrganizationsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationsListQuery, OrganizationsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationsListQuery, OrganizationsListQueryVariables>(OrganizationsListDocument, options);
        }
export type OrganizationsListQueryHookResult = ReturnType<typeof useOrganizationsListQuery>;
export type OrganizationsListLazyQueryHookResult = ReturnType<typeof useOrganizationsListLazyQuery>;
export type OrganizationsListSuspenseQueryHookResult = ReturnType<typeof useOrganizationsListSuspenseQuery>;
export type OrganizationsListQueryResult = Apollo.QueryResult<OrganizationsListQuery, OrganizationsListQueryVariables>;